// extracted by mini-css-extract-plugin
export var deliveryRow = "_nk-a";
export var fixedHeight = "_nk-4";
export var freightLogo = "_nk-9";
export var fullWidth = "_nk-3";
export var priceColumn = "_nk-5";
export var radioSelected = "_nk-7";
export var radioUnselected = "_nk-6";
export var selectedOption = "_nk-2";
export var selectedOptionContainer = "_nk-1";
export var selection = "_nk-0";
export var tallSkeletonText = "_nk-8";